// dtnga3 (17.03.2023) Loại đánh dấu màn hình kiểm tra báo cáo

export default {
  All: 1, // Kiểm tra tất cả bc trong bộ BCTC, bao gồm C03

  OnlyC03: 2, // kiểm tra tại màn hình lập C03
  OnlyBCTC: 3, // Kiểm tra tại màn hình lập bộ BCTC (B01, B04, ...)
};
